module.exports = __webpack_public_path__ + "live-tip-close-77eb6637.png";